/**
 * InstallationsPublicRpcClient - AtomRpc integration for customer-facing
 * installation endpoints. Hosts the public onboarding wizard RPCs plus the
 * `installation.provisioningEventStream` introduced by CLA-220 Task 002.
 *
 * Uses Clerk session auth so the stream's auth middleware can verify the
 * caller is a member of the install's direct customer. The wizard's
 * non-streaming endpoints accept the install id in their payload as a
 * bearer-equivalent and don't require a session — but providing one here
 * is harmless because the unauth'd routes do not enforce middleware.
 *
 * @since 1.0.0
 */
import { AtomRpc } from "@effect-atom/atom-react";
import { FetchHttpClient } from "@effect/platform";
import { RpcSerialization } from "@effect/rpc";
import { InstallationsPublicRpcs } from "@fm/api/rpc";
import { Layer } from "effect";
import { InstallerTokenMiddlewareClientLive, makeRpcClientLayer, makeTokenGetterLayer } from "./shared.ts";

export class InstallationsPublicRpcClient extends AtomRpc.Tag<InstallationsPublicRpcClient>()(
  "InstallationsPublicRpcClient",
  {
    group: InstallationsPublicRpcs,
    protocol: Layer.merge(
      makeRpcClientLayer(InstallationsPublicRpcs),
      InstallerTokenMiddlewareClientLive,
    ).pipe(
      Layer.provide(RpcSerialization.layerNdjson),
      Layer.provide(makeTokenGetterLayer()),
      Layer.provide(FetchHttpClient.layer),
    ),
  },
) {}
